import dynamic from "next/dynamic";
import renderCallback from "../../renderCallback";
// @ts-ignore
const Render = dynamic(() => import('./View').then((c) => c.default));


export default function Form(ref?: any) {
	return renderCallback(ref, 'form', Render)
}